import { useContext } from 'react';
import { ApiContext, StateContext, ForceUpdateContext } from './context.js';
export var useApi = function useApi() {
  return useContext(ApiContext);
};
export var useRootState = function useRootState() {
  return useContext(StateContext);
};
export var useForceUpdate = function useForceUpdate() {
  return useContext(ForceUpdateContext);
};